import React, { Component } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import RenditionUrlGenerator from "../../../utils/api/renditionUrlGenerator";
import { isEmpty, isEqual } from 'lodash';
import { getCVFrameUrl } from '../../../utils/general/general';

interface IKeyResearchChangesProps {
    source?: any;
    docHeaderSectionJson: any;
    isExternalUser?: boolean;
    menuCode: any;
}

export class KeyResearchChanges extends Component<IKeyResearchChangesProps, any> {
    constructor(props: IKeyResearchChangesProps) {
        super(props);
    }

    public render() {
        const {docHeaderSectionJson, isExternalUser, menuCode} = this.props;
        const environment = window.HTML_RENDITION.initialData.environment;
        const keyResearchUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + "/rsch/datadashboard/keyresearchchangesui/eppublic/";
        let url = RenditionUrlGenerator.URL_GENERATOR.environments(environment)+ '/cv2/go/RSCH_LANDING_PAGE/' + btoa('__NAVIGATION_BASE64__/cvr/citiresearchui/eppublic/pdp_all/iframe/' + btoa(keyResearchUrl));
        if (isExternalUser) {
            url = keyResearchUrl;
        } else if (!isEmpty(menuCode) && !isEqual(menuCode, 'RSCH_LANDING_PAGE')) {
            url = getCVFrameUrl(menuCode, keyResearchUrl, 'pdp_all');
        }
        return (
            <React.Fragment>
                <div className="keyResearchChanges"
                     onClick={() => {
                        window.open(url, isExternalUser ? "_self" : "_blank");
                        RSCH_HTML_TRACKING_CONFIG.trackKeyResearchChanges();
                     }}
                     onKeyPress={(e) => {
                        window.open(url, isExternalUser ? "_self" : "_blank");
                        RSCH_HTML_TRACKING_CONFIG.trackKeyResearchChanges();
                     }}
                >
                    <span className='icon-svg-parent'>
                        <span className="icon-svg icon-key-research-changes-svg" role="img" aria-label="Key Research Changes" />
                    </span>
                    <a tabIndex={0} role="link" className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.keyResearchChanges}>{docHeaderSectionJson.i18n.keyResearchChanges}</a>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        menuCode: state.commonStateReducer.menuCode
    };
};

export default connect(mapStateToProps)(KeyResearchChanges);
